<template>
  <!-- Add -->
  <b-modal
    id="modalAdd"
    ref="my-modal"
    title="Add User"
    size="1.714rem"
    ok-title="Accept"
    cancel-title="Close"
    @show="resetModal"
    @hidden="resetModal"
    @ok="handleOk"
  >
    <validation-observer ref="simpleRules">
      <b-row>
        <!-- First name -->
        <b-col cols="12">
          <b-form-group
            label="First name"
            label-for="firstname"
          >
            <validation-provider
              #default="{ errors }"
              name="First name"
              rules="required"
            >
              <b-input-group class="input-group-merge">
                <b-form-input
                  id="firstname"
                  v-model="addData.firstname"
                  :state="errors.length > 0 ? false:null"
                  required
                  type="text"
                  placeholder="First name"
                />
              </b-input-group>
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </b-col>

        <!-- LAST NAME -->
        <b-col cols="12">
          <b-form-group
            label="Last Name"
            label-for="lastname"
          >
            <validation-provider
              #default="{ errors }"
              name="Last Name"
              rules="required"
            >
              <b-input-group class="input-group-merge">
                <b-form-input
                  id="lastname"
                  v-model="addData.lastname"
                  :state="errors.length > 0 ? false:null"
                  required
                  type="text"
                  placeholder="Last Name"
                />
              </b-input-group>
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </b-col>

        <!-- DEPARTMENT -->
        <b-col cols="12">
          <b-form-group
            label="Role"
            label-for="role"
          >
            <validation-provider
              #default="{ errors }"
              name="Role"
              rules="required"
            >
              <v-select
                v-model="addData.groupname"
                :reduce="groupname => groupname.GroupName"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :state="errors.length > 0 ? false:null"
                required
                label="GroupDescription"
                :options="groupname"
                transition=""
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </b-col>

        <!-- Username -->
        <b-col cols="12">
          <b-form-group
            label="Username"
            label-for="username"
          >
            <validation-provider
              #default="{ errors }"
              name="Username"
              rules="required"
            >
              <b-input-group class="input-group-merge">
                <b-form-input
                  id="username"
                  v-model="addData.username"
                  :state="errors.length > 0 ? false:null"
                  required
                  type="text"
                  placeholder="Username"
                />
              </b-input-group>
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </b-col>
        <!-- password -->
        <b-col cols="12">
          <b-form-group
            label="Password"
            label-for="password"
          >
            <validation-provider
              #default="{ errors }"
              name="Password"
              rules="required"
            >
              <b-input-group class="input-group-merge">
                <b-form-input
                  id="password"
                  v-model="addData.password"
                  type="password"
                  :state="errors.length > 0 ? false:null"
                  required
                  placeholder="Password"
                />
              </b-input-group>
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </b-col>

        <template #code>
          {{ codeFeedbackHelper }}
        </template>
      </b-row>
    </validation-observer>
  </b-modal>
</template>

<script>
import axios from '@axios'
import {
  BRow, BCol, BFormGroup, BInputGroup, BFormInput,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import { required } from '@validations'
import { ValidationProvider, ValidationObserver } from 'vee-validate'

export default {
  components: {
    BRow,
    BCol,
    BFormGroup,
    BInputGroup,
    BFormInput,
    vSelect,
    ValidationProvider,
    ValidationObserver,
  },
  data() {
    return {
      required,
      role: [],
      username: null,
      password: null,
      addData: {
        firstname: '',
        lastname: '',
        role: '',
        groupname: '',
        username: '',
        password: '',
      },
    }
  },
  mounted() {
    this.dropdownRole()
  },
  methods: {
    checkFormValidity() {
      const valid = this.$refs.form.checkValidity()
      // this.addData.username = ''
      // this.addData.password = ''
      this.username = valid
      this.password = valid
      return valid
    },
    resetModal() {
      this.addData.firstname = ''
      this.addData.lastname = ''
      this.addData.role = ''
      this.addData.groupname = ''
      this.addData.username = ''
      this.addData.password = ''
    },
    handleSubmit() {
      // Exit when the form isn't valid
      if (!this.checkFormValidity()) {
        return
      }
      this.addInfo()
      this.$nextTick(() => {
        this.$refs['my-modal'].toggle('#toggle-btn')
      })
    },
    handleOk(bvModalEvt) {
      // Prevent modal from closing
      bvModalEvt.preventDefault()
      // Trigger submit handler
      this.validationForm()
    },
    validationForm() {
      this.$refs.simpleRules.validate().then(success => {
        if (!success) {
          // eslint-disable-next-line
          return
        }
        this.addInfo()
        this.$nextTick(() => {
          this.$bvModal.hide('modalAdd')
        })
      })
    },

    // เพิ่มข้อมูลปุ่ม Add
    async addInfo() {
      // eslint-disable-next-line global-require
      const bcrypt = require('bcryptjs')
      const hash = bcrypt.hashSync(this.addData.password)
      const payload = {
        ...this.addData,
        firstname: this.addData.firstname,
        lastname: this.addData.lastname,
        password: hash,
        role: this.addData.groupname,
        groupname: this.addData.groupname,
        username: this.addData.username,
      }
      console.log(payload)
      axios
        .post('/add-userNPT', payload)
        .then(response => {
          console.log(response)
          this.$swal({
            icon: 'success',
            title: '<span style="color:#000000">Add Successfully.</span>',
            showConfirmButton: false,
            timer: 1000,
          })
          this.addData.firstname = ''
          this.addData.lastname = ''
          this.addData.role = ''
          this.addData.groupname = ''
          this.addData.username = ''
          this.addData.password = ''
          this.$emit('fetch')
        })
        .catch(error => {
          console.log(error.response)
          this.$swal({
            icon: 'error',
            text: error.response.data.message,
            showConfirmButton: false,
            timer: 2000,
          })
          this.addData.firstname = ''
          this.addData.lastname = ''
          this.addData.role = ''
          this.addData.groupname = ''
          this.addData.username = ''
          this.addData.password = ''
        })
    },
    dropdownRole() {
      axios
        .get('/dropdown-roleNPT')
        .then(response => {
          this.groupname = response.data
        })
    },
  },
}
</script>
